import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Password, Button, LoginLayout, Toast } from "@app/components";
import { FormFlexWrapper, FlexWrapper } from "@app/components/commonStyles";
import { passwordPattern } from "@app/utils";
import { logoutUser, resetPassword } from "@app/services";
import { ButtonContainer } from "./reset-password-component";
import { AuthContext } from "@app/providers";

export default function ResetPassword() {
  const { register, handleSubmit, watch, errors, getValues, trigger } =
    useForm();
  const userData: any = useParams();
  const { userInfo, setUserInfo } = useContext(AuthContext);

  // const { navigate } = useLocation();
  const [showToast, setShowToast] = useState(false);
  const [buttonText, setButtonText] = useState<string>("Reset");
  let history = useHistory()
  const location = useLocation();
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const resetPath = location.pathname.split('/');
  const query: any = new URLSearchParams(location.search);
  const emailToken = resetPath[2];
  const passwordToken = resetPath[3];
  useEffect(() => {
    if (resetPath.length > 1 && resetPath[1] === "resetpassword") {
      logout()
    }
  }, [])

  function logout() {
    const params: any = {};
    Object.assign(params, {
      userId: userInfo && userInfo.userJson.userId,
      sessionToken: userInfo && userInfo.sessionToken,
    });
    logoutUser(params)
      .then((res: any) => {
        if (res._responseStatus === 1) {
          localStorage.clear();
          setUserInfo(null);
        } else if (res.msgCode === "SSN_002") {
          localStorage.clear();
          setUserInfo(null);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  function onPasswordBlur() {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
  }

  async function onSubmit(data: any) {
    const params: any = {};
    Object.assign(params, {
      email: emailToken,
      password: data.password,
      passwordToken: passwordToken,
      confirmPassword: data.confirmPassword,
    });
    setButtonText("Reseting...");
    resetPassword(params)
      .then((res) => {
        setButtonText("Reset");
        if (res._responseStatus) {
          setToastMessage({
            type: "success",
            message: "You can now sign in now with your new password.",
          });
          setShowToast(true);
          setTimeout(() => {
            history.replace("/");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setButtonText("Reset");
        setToastMessage({
          type: "error",
          message: "Something went wrong, Please try again.",
        });
        setShowToast(true);
      });
  }

  return (
    <>
      <LoginLayout path="" label="">
        <h3 className="primary-header text-center mb-3">Reset Password</h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Password
                hideLabel={true}
                hideIcon={true}
                placeholder="New Password"
                name="password"
                showInfo={false}
                showInstructions={true}
                register={register({
                  required: true,
                  pattern: passwordPattern,
                })}
                onBlur={onPasswordBlur}
                error={
                  (errors.password &&
                    errors.password.type === "required" &&
                    "Please enter New Password") ||
                  (errors.password &&
                    errors.password.type === "pattern" &&
                    "Please enter a Strong Password")
                }
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper>
            <div className="child only-child">
              <Password
                hideLabel={true}
                hideIcon={true}
                placeholder="Confirm Password"
                name="confirmPassword"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value === watch("password");
                  },
                })}
                error={
                  (errors.confirmPassword &&
                    errors.confirmPassword.type === "required" &&
                    "Please confirm Password") ||
                  (errors.confirmPassword &&
                    errors.confirmPassword.type === "validate" &&
                    "Passwords did not match")
                }
              />
            </div>
          </FormFlexWrapper>
          <FlexWrapper className="justify-end">
            <ButtonContainer
              disabled={buttonText === "Reseting..."}
              style={{ width: "unset" }}
            >
              <Button variant="newsecondary" type="submit">
                {buttonText}
              </Button>
            </ButtonContainer>
          </FlexWrapper>
        </form>
        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        />
      </LoginLayout>
    </>
  );
}
